import type {Optional} from '@logistics-frontend/types'
import {get} from '@logistics-frontend/utils'

import type {GeoPoint} from 'src/shared/types'

export function toGeoLocation(location: Optional<number[]>): Optional<GeoPoint> {
  if (location === undefined) {
    return undefined
  }

  return {
    lon: get('[0]', location),
    lat: get('[1]', location),
  }
}
